import { create, test, enforce } from 'vest';
import isEmail from 'validator/es/lib/isEmail';

enforce.extend({ isEmail });

const validate = create((formData) => {
    test('firstname', 'First name is empty', () => {
        enforce(formData.firstname).isNotEmpty();
    });

    test('lastname', 'Last name is empty', () => {
        enforce(formData.lastname).isNotEmpty();
    });

    test('email', 'Email is empty', () => {
        enforce(formData.email).isNotEmpty();
    });

    test('email', 'Email is not valid', () => {
        enforce(formData.email).isEmail();
    });

    test('organisation', 'Organisation is empty', () => {
        enforce(formData.organisation).isNotEmpty();
    });
});

export default validate;
